// extracted by mini-css-extract-plugin
export default {"path":"TickIcon_path__I0gWm"};